const epsHeadersJSON = require("./eps-headers.json");

export namespace EPSTest {

  export class Configurator {

    headersCollection: HeaderGroup[];
    useSandbox: boolean;
    
    constructor(persistance?: EPSPersistance) {
      this.headersCollection = persistance ? persistance.headersCollection 
                                : epsHeadersJSON as HeaderGroup[];
      this.useSandbox = persistance ? persistance.useSandbox : false;
    }

    toPersistance(): EPSPersistance {
      return {
        useSandbox: this.useSandbox,
        headersCollection: this.headersCollection,
      }
    }

    toRequestBody(needMeta: boolean = false) {
      const body = {};
      this.headersCollection.forEach(it => {
        if (this.selected(it.id)) {
          body[it.id] = this.getHeaderById(it.id);
        }
      });

      if (needMeta) {
        body['show_supplier_meta_data'] = true;
      }
    
      return body;
    }

    getHeaderById(id: HeadersGroupId): Headers {
      return this.headersCollection.find(it => it.id === id).selected;
    }

    selected(id: HeadersGroupId): boolean {
      return this.getHeaderById(id) != Headers.none;
    } 



  }

  export enum Headers {
    none = 'none',
    standard = 'standard',
    forbidden = 'forbidden',
    noAvailability = 'no_availability',
    matched = 'matched',
    priceChanged = 'price_changed',
    soldOut = 'sold_out',
    all = 'all',
    night = 'night',
    amount = 'amount',
    percent = 'percent',
    remainder = 'remainder',
    unknownInternalError = 'unknown_internal_error',
    initSkip = 'init_skip',
    initFail = 'init_fail',
    initTimeout = 'init_timeout',
    completePaymentSession = 'complete_payment_session',
    completePaymentSessionShow = 'complete_payment_session_show',
    completePaymentSessionFail = 'complete_payment_session_fail',
    completePaymentSessionError = 'complete_payment_session_error',
    completePaymentSessionTimeout = 'complete_payment_session_timeout',
    ccDeclined = 'cc_declined',
    internalServerError = 'internal_server_error',
    serviceUnavailable = 'service_unavailable',
    paymentDeclined = 'payment_declined',
    priceMismatch = 'price_mismatch',
    roomsUnavailable = 'rooms_unavailable',
    postStayCancel = 'post_stay_cancel',
  } 

  export enum HeadersGroupId {
    shop = 'test_shop_header',
    priceCheck = 'test_price_check_header',
    registerPayment = 'test_register_payment_header',
    createBooking = 'test_book_header',
    completePayment = 'test_complete_payment_header',
    retriveBooking = 'test_info_header',
    cancelBooking = 'test_cancel_header'
  } 

  export interface SelectedHeader {
    id: HeadersGroupId;
    key: Headers; 
  }
  
  export interface EPSPersistance {
		useSandbox: boolean;
    headersCollection: HeaderGroup[];
	}


  export interface HeaderGroup {
    id: HeadersGroupId;
    title: string;
    selected: Headers;
    headers: Headers[];
  }

}